<template>
  <Row>
    <Col span="18">
        <span ref="brick"></span>
        <Treeselect 
            v-model="categoryCode" 
            :data="selectData"
            text-field-name="name"
            value-field-name="code"
            size="small"
            placeholder="请选择所属分类"
            class="public-inp"
        ></Treeselect>
        <Select v-model="status" placeholder="请选择状态" class="public-inp">
            <Option value="" >全部</Option>
            <Option value="0" >启用</Option>
            <Option value="1" >禁用</Option>
        </Select>
        <Select v-model="brandCode" placeholder="请选择品牌" class="public-inp">
            <Option v-for="item in brandCodeList" :value="item.code" :key="item.code">{{ item.name }}</Option>
        </Select>
        <Button type="primary" icon="md-search" @click="getList()" v-access="'spuInfo.query'">搜索</Button>
        <Button @click="resetList()" v-access="'spuInfo.reset'">重置</Button>
    </Col>
    <Col span="6">
      <Button type="primary"
              icon="md-add"
              class="public-fr"
              v-access="'spuInfo.add'"
              @click="openFn()">添加SPU</Button>
    </Col>
    <Col span="24">
        <Table
            :style="{marginTop:'10px'}"
            border
            stripe
            :loading="loading"
            :columns="columns"
            :data="tbList">
            <template slot-scope="{ row,index }" slot="sort">
                <span v-show="false">{{row.code}}</span>
                {{(page-1)*pageSize+index+1}}
            </template>
            <template slot-scope="{ row,index }" slot="status">
                <i-switch :value="row.status==0" @on-change="(v)=>stateChange(v,row,index)" size="small" v-access="'spuInfo.status'" />
            </template>
            <template slot-scope="{ row }" slot="avatar">
                <Avatar :src="row.d" />
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <a href="javascript:;"
                    @click="openFn(row,index)" v-access="'spuInfo.edit'">编辑</a>
                <a href="javascript:;"
                    @click="removeFn(index,row)" v-access="'spuInfo.delete'">删除</a>
            </template>
        </Table>
        <Page 
        :total="total" 
        show-sizer 
        show-total 
        prev-text="上一页" 
        next-text="下一页" 
        show-elevator 
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
                class="public-page"
        />
    </Col>
  </Row>
</template>
<script>
  import Treeselect from 'vue-treeselect';
const columns = [
  {
    title: '序号',
    slot: 'sort',
    width: 60
  },
  {
    title: '名称',
    key: 'name'
  },
  {
    title: '排序',
    key: 'sortIndex'
  },
  {
    title: '所属分类',
    key: 'categoryName'
  },
  {
    title: '品牌',
    key: 'brandName'
  },
  {
    title: '状态',
    slot: 'status',
  },
  {
    title: '是否陈列',
    key: 'checkFlag',
    render: (h, params) => {
        // 0：不巡检；1：需要门店上传巡检
        let s = params.row.checkFlag;
        let t = s==1?'需要门店上传巡检':'不巡检';
        return h('span', t);
    },
  },
  {
    title: '操作',
    slot: 'action',
    width: 150
  }
];
    export default {
        name:'spuInfo',
        components:{
            Treeselect
        },
        data () {
            return {
                loading:false,
                columns,
                tbList:[],
                total:0,
                brandCode:'',
                brandCodeList:[],
                categoryName:'',
                categoryCode:'',
                selectData:[],
                status:'',
                page:1,
                pageSize:10
            }
        },
        created(){
            this.getTree();
            this.getBrand();
            this.getList();
        },
        watch:{
            // tree选择后收起选项
            'categoryCode'(a,b){
            this.$refs.brick.click();
            },
            deep:true
        },
        methods: {
            // 全部分类
            getTree(){
                this.$api['categoryAll']({}).then((res) => {
                    if (res.code == '200') {
                    let selectSt = {
                        name:'全部分类',
                        code:'',
                        opened:false,
                        parentCode:'-1'
                    }
                    let list = [];
                    if(res.data && res.data.length>0){
                        list = [...res.data,selectSt];
                    }
                    this.selectData = this.tools.arrayToTree(list,1);
                    }
                })
            },
            // 全部品牌
            getBrand(){
                this.$api.brandAll({}).then((res) => {
                    if(res.code == '200'){
                        let list = res.data;
                        if (!list || list.length == 0) {
                            this.brandCodeList = [];
                            return
                        }
                        this.brandCodeList = list;
                    }
                });
            },
            // 列表
            getList(){
                let data = {
                    brandCode:this.brandCode,
                    categoryCode:this.categoryCode,
                    page:this.page,
                    pageSize:this.pageSize,
                    status:this.status,
                }
                this.loading = true;
                this.$api.spuSearch(data).then(res=>{
                    this.loading = false;
                    if(res.code=='200'){
                        this.tbList = res.data;
                        this.total = res.total;
                    }
                })
            },
            // 页码
            pageChange(d){
                this.page = d;
                this.getList();
            },
            // 页数
            pageSizeChange(d){
                this.pageSize = d;
                this.getList();
            },
            // 重置
            resetList(){
                this.brandCode = '';
                this.categoryCode = '';
                this.name = '';
                this.status = '';
                this.page = 1;
                this.pageSize = 10;
                this.$nextTick(()=>{
                    this.getList();
                })
            },
            // 打开新增编辑
            openFn(d,i){
                this.$router.replace({ path: '/spuEdit', query: { code: d?d.code:'' }})
            },
            // 删除部门
            removeFn(i, d) {
                this.$Modal.confirm({
                    title: '提示',
                    content: `确认删除${d.name}`,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: async () => {
                        this.$api.spuDelete({code:d.code}).then((res) => {
                            if(res.code == '200'){
                                this.$Message.success('删除成功');
                                this.getList();
                            }
                        });
                    }
                })
            },
            // 状态
            stateChange(v,d,i){
                let http = d.status==0?'spuDisable':'spuEnable';
                this.$api[http]({code:d.code}).then((res) => {
                    if(res.code == '200'){
                        this.$Message.success(v?'启用成功':'禁用成功');
                        this.getList();
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/commodity/spuInfo.vue